import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGE } from '@/constants/common';
import {
  EquityTermLoanPropertyType,
  RESIDENTIAL_GEARING_RATIO,
} from '@/constants/others/equity-term-loan';
import { FormTypes } from '.';

export const initialState = {
  formField: {
    estimatedMVP: 1500000,
    propertyType: EquityTermLoanPropertyType.RESIDENTIAL,
    gearingRatio: RESIDENTIAL_GEARING_RATIO.DEFAULT.toString(),
    outstandingLoan: 0,
    cpfUsed: 0,
    cpfAccruedInterest: 0,
  } as FormTypes,
  loading: true,
  from: '' as PAGE | '',
};

export const equityTermLoanSlice = createSlice({
  name: 'equityTermLoan',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { updateDataForm, updateFrom, reset } = equityTermLoanSlice.actions;

export default equityTermLoanSlice.reducer;
